import React from "react";
import Collapsible from "react-collapsible";
import HttpServices from "../../../utils/Http.services";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import FormViewer from "../../FormViewer";
import LoaderButton from "../../LoaderButton";
import SidebarView from "../../SidebarView";
import StagesManager from "../../StagesManager";
import TableViewer from "../../TableViewer";

class DiagramTopbar extends React.Component {

    state = {

        closedGroups: {},
        // showChildsSide: false,
        // sideOpen: true,
        parts: [
            // { label: '{{lang}}Rules', key: 'rules', icon: '/assets/icons/useful/action.png' },
            // { label: '{{lang}}Inuse', key: 'inuse', icon: '/assets/icons/useful/list-text.png' },
            { label: '{{lang}}Variables', key: 'variables', icon: '/assets/icons/useful/text.svg' },


        ],

        selectedParent: { type: "flowControl", _id: this.props.variables.appletId, default: true },

        applets: [
            // { _id: '1', name: '{{lang}}Accounting', type: 'finance', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '2', name: '{{lang}}Booking', type: 'booking', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '3', name: '{{lang}}Tasking', type: 'tasking', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '4', name: '{{lang}}Commerce', type: 'commerce', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '5', name: '{{lang}}Messenger', type: 'messenger', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '6', name: '{{lang}}Developers', type: 'developers', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '7', name: '{{lang}}Sequence', type: 'sequence', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '8', name: '{{lang}}Drive', type: 'drive', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '9', name: '{{lang}}Rooms', type: 'rooms', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '10', name: '{{lang}}Ticketing', type: 'ticketing', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '11', name: '{{lang}}Social', type: 'social', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '12', name: '{{lang}}Wallet', type: 'wallet', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '13', name: '{{lang}}Question', type: 'question', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '14', name: '{{lang}}Email', type: 'email', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '15', name: '{{lang}}Notebook', type: 'notebook', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '16', name: '{{lang}}Database', type: 'database', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '17', name: '{{lang}}Tracking', type: 'tracking', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '18', name: '{{lang}}Inventory', type: 'inventory', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '19', name: '{{lang}}Connections', type: 'connections', icon: '/assets/profile-def.png', isParent: true },
            // { _id: '20', name: '{{lang}}CRM', type: 'crm', icon: '/assets/profile-def.png', isParent: true },
        ],
        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false } },
            { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: true } },
        ],
        varHeader: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false } },
            { key: 'dataType', type: 'SelectInput', col: '12', information: { label: '{{lang}}data type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'String', value: 'String' }, { title: 'Number', value: 'Number' }, { title: 'Boolean', value: 'Boolean' }, { title: 'Object', value: 'Object' }, { title: 'List', value: 'List' }, { title: 'User', value: 'User' }], required: true } },
            { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'global', value: 'global' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: true } },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },
            {
                key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value', placeholder: '{{lang}}value', required: false },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'value',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'applet' } },
                                2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'hub' } },
                                2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'global' } }

                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },

        ],
    }

    componentDidMount() {
        console.log('state selectedParent', this.state.selectedParent)
        this.getMyApplets()
        // $('[draggable=true]').each((index,drag) => {
        //     // draggable.draggable()
        //     // console.log(draggable)
        //     // console.log(index)
        //     drag.draggable();
        // })
        // .draggable()
        // let draggables = document.querySelectorAll('[draggable=true]');
        // draggables = [...draggables]
        // draggables.forEach(draggable => {
        //     console.log(draggable)
        //     draggable.addEventListener('dragstart', (e) => console.log(e));
        // });
        // console.log(draggables)
        //    draggables.forEach(
    }

    getMyApplets = () => {
        let data = {}
        data.username = this.props.variables.user?.username
        HttpServices.request('getHubByUsername', data, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('fetchError', fetchError)
                return
            }
            // console.log('fetcheer', fetchResult.applets)

            fetchResult.applets.forEach(element => {
                element.isParent = true
            });
            this.setState({ applets: fetchResult.applets })
        })
    }
    // open = () => {
    //     this.sidebarView.open()
    // }

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    // toggleSideOpen = () => {
    //     let sideClose = this.state.sideClose == null ? true : !this.state.sideClose
    //     this.setState({ sideClose })
    //     if (sideClose) {
    //         this.subSidebarView.closeSidebar()
    //         // this.setState({ showChildsSide: false })
    //     }
    //     if (this.state.selectedParent && !sideClose) {
    //         // this.setState({ showChildsSide: true })
    //         this.subSidebarView.openSidebar()

    //     }
    // }


    showChildsList = (parent) => {


        // this.setState({ showChildsSide: !this.state.showChildsSide })
        if (parent) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: parent })
        } else {
            this.subSidebarView.closeSidebar()
            setTimeout(() => {
                this.setState({ selectedParent: parent })
            }, 500);
        }
    }

    showApplet = (applet) => {
        // console.log(applet)
        console.log('showApplet', applet)
        if (applet) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: applet })
        }
    }
    openVariables = () => {
        this.varSidebarView.open()
        // console.log('var', this.props.variables)
        // let data = {}
        // data.applet = this.props.variables.appletId
        // HttpServices.request('getVariables', data, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         return
        //     }
        //     console.log('fetchReusult', fetchResult.info)
        //     this.setState({ variables: fetchResult.info }, () => {
        //     })
        // })
    }
    addNewVariables = () => {
        this.stageManager.changeStage('addNew')
    }
    backStage = (stage) => {
        this.stageManager.changeStage(stage)
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'DiagramEditor') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    saveVariables = () => {
        let data = this.form.getForm() ?? {}
        console.log('this.props.variables', { ...this.props.variables })
        data.applet = this.props.variables.appletId
        data.appletHub = this.props.variables.appletHub._id
        if (data.type) {
            HttpServices.request('postVariables', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                let variablesList = this.props.variablesList ?? []
                variablesList.push(fetchResult.info)
                this.setData('variablesList', variablesList, 'DiagramEditor', () => {
                    this.backStage('main')
                })

            })
        }
    }
    onTouchMove = (e, prop) => {
        // console.log("onTouchMove")
        let x
        let y
        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }

        // console.log(x)
        // console.log(y)

        let id = prop.key

        if (this.state.dragId !== id && this.dragOverId != id) {
            this.setState({ dragId: id })


            // this.dragOverId = id
            // this.animateSorting(this.state.dragId, id)
        }
        let ghost = document.getElementById('drag-ghost')
        // console.log(ghost)

        if (ghost) {
            ghost.style.top = (y - Number(ghost.style.height.replace('px', '')) / 2) + 'px'
            ghost.style.left = (x - Number(ghost.style.width.replace('px', '')) / 2) + 'px'
        }
        // console.log(y)
    }

    onTouchEnd = (e) => {
        this.setState({ dragId: null })
        this.props.onDrop(e)

    }

    onClick = (cprop) => {
        console.log('onClick')
        if (cprop.isParent) {
            this.showChildsList(cprop)
        } else {
            if (!this.props.draggable) {

                // this.sidebarView.close()
                // this.subSidebarView.close()
                this.props.onClick(cprop, this.state.selectedParent?.type)
            }
        }
    }

    chooseParent = (data) => {
        let item = data
        if (typeof item != 'object') {
            item = { features: ['flowControl'], default: true }
        }
        // if (item.features[0] != this.state.selectedParent?.type) {
        if (this.state.selectedParent?._id != item?.applet?._id || (!this.state.selectedParent?._id && this.state.selectedParent?.type != item.features[0])) {
            // let selectedParent = this.state.selectedParent 
            let selectedParent = { type: item.features[0], _id: item?.applet?._id ?? this.props.variables.appletId, default: item.default }
            this.setState({ selectedParent })
        } else {
            this.setState({ selectedParent: null })
        }

    }

    render() {
        if (this.props.showElements) {
            return (
                <>

                    <div className="" style={{ position: 'fixed', width: 'calc(100% - 50px)', top: 62, left: 50, zIndex: 10, backgroundColor: '#fffffff0', boxShadow: '0px 10px 10px #10101005' }}>
                        {/* <SidebarView width={this.props.width} ref={el => this.sidebarView = el} sideOpen={this.props.sideOpen} hideOverlay={this.props.hideOverlay} paddingTop={'62px'} widthCondition={{ xs: "12", sm: '28%', md: '28%', lg: "28%", xl: "20%" }}> */}

                        {/* <div className={"sidePanel digramSidePanel " + (conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ width: conditionalWidth(this.props.width, { xs: '80%', md: '200px' }) }}>
                    <div className='sidePanel-content  h-100 blur-back  ' style={{ backgroundColor: '#fff' }} > */}
                        <div className="d-flex formItems-container pt-1  ">
                            <div className=" text-start w-100  ">
                                {/* <p className="text-semibold text-normal mb-2 px-2" style={{ color: '#101010' }}>{translate('Create the flow')}</p> */}
                                <div className="flexcb pt-1 pb-2 px-2 scroll-no-scrollbar" style={{ borderBottom: '1px solid #f8f8f8' }}>
                                    <div className="flexc ">
                                        {/* <div className=" px-2">
                                        <div className="br-20 flexc" style={{ backgroundColor: '#eee', padding: '4px 4px 4px 4px' }}>
                                            <input className="transpanet-input text-small px-1 " placeholder={translate("Search")} />
                                        </div>
                                    </div> */}



                                        <button className="  px-1  text-start " style={{}} onClick={() => this.openVariables()}>
                                            {/* <p className="text-semibold text-small color-gray-3">{translate(prop.label)}</p> */}
                                            <div className="flexc br-6  " style={{ padding: '8px 12px', backgroundColor: '#eee' }}>
                                                <img className="mrd-2" src={'/assets/icons/useful/text.svg'} height={14} />
                                                <p className="text-small text-semibold " style={{ color: '#202020' }}>{checkTranslation("Variables")}</p>
                                            </div>

                                            {/* <div className="flexc">
                                            <div className="white flexcc" style={{ minWidth: 20, height: 20, backgroundColor: '#007aff', borderRadius: 30 }}>
                                                <p className="text-smaller text-semibold">{index + 1}</p>
                                            </div>

                                        </div> */}

                                        </button>


                                        <button className="  px-1  text-start " onClick={() => this.chooseParent('flowControl')} style={{}}>
                                            <div className="flexc br-6  " style={{ padding: '8px 12px', backgroundColor: this.state.selectedParent?.type == 'flowControl' ? '#2872e1' : '#eee' }}>
                                                <img className={"mrd-2  " + (this.state.selectedParent?.type == 'flowControl' ? 'invert' : '')} src={'/assets/icons/useful/text.svg'} height={14} />
                                                <p className="text-small text-semibold " style={{ whiteSpace: 'nowrap', color: this.state.selectedParent?.type == 'flowControl' ? '#fff' : '#000' }}>{checkTranslation("Flow Control")}</p>
                                            </div>
                                        </button>




                                        {this.state.applets.map((cprop, index) => {
                                            // let isSelected = this.state.selectedParent == cprop._id
                                            let isSelected = false
                                            if (this.state.selectedParent != null) {
                                                if ((this.state.selectedParent._id == cprop?.applet?._id && !this.state.selectedParent.default) || (!this.state.selectedParent._id && this.state.selectedParent.type == cprop.features[0])) {
                                                    isSelected = true
                                                }

                                            }
                                            else {
                                                isSelected = false
                                            }
                                            console.log('isSelected', isSelected)
                                            console.log('this.state.selectParent9', this.state.selectedParent)
                                            // let isSelected = this.state.selectedParent?.type == cprop.features[0]
                                            // console.log('cpropis', cprop)
                                            return (

                                                <div className=" mrd-2 mb-0" key={cprop.key}>
                                                    {/* <div className="flexcb text-center br-6 " onClick={() => { if (cprop.isParent) this.chooseParent(cprop._id) }} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '2px 4px 2px 4px', cursor: !cprop.isParent ? 'move' : 'pointer', borderBottom: '0px solid #f2f2f2', backgroundColor: (isSelected) ? "#2872e1" : '#eee' }}> */}
                                                    <div className="flexcb text-center br-6 " onClick={() => { if (cprop.isParent) this.chooseParent(cprop) }} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '2px 4px 2px 4px', cursor: !cprop.isParent ? 'move' : 'pointer', borderBottom: '0px solid #f2f2f2', backgroundColor: (isSelected) ? "#2872e1" : '#eee' }}>
                                                        <div className="flexc prd-4">
                                                            <img className={"" + (isSelected ? '' : '')} draggable={false} src={imageAddress(cprop.applet.image)} width="24x" height={'24x'} alt="" style={{ objectFit: 'cover', borderRadius: '30px', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                            <div className="text-start mld-3">
                                                                <p className="mt-0  text-semibold  " style={{ fontSize: 12, whiteSpace: 'nowrap', color: isSelected ? '#fff' : '#000' }} >{checkTranslation(cprop.applet.name)}</p>
                                                                <p className="mt-0   color-gray-3" style={{ fontSize: 10, color: isSelected ? '#fff' : null }} >{cprop.features[0]}</p>
                                                            </div>
                                                        </div>

                                                        {/* <div className="flexcc">
                                                        {cprop.isParent && (
                                                            <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                        )}
                                                    </div> */}
                                                    </div>
                                                </div>

                                            )
                                        })}




                                    </div>


                                    {/* <button className="  px-1  text-start " style={{}}>
                                    <div className="flexc br-20 px-2 py-2 flexc" style={{ backgroundColor: '#eee' }}>
                                        <img className="" src={'/assets/icons/down-arrow.svg'} height={14} />
                                    </div>

                                </button> */}

                                    {/* {this.state.parts.map((prop, index) => {
                                return (
                                    <button className="  px-1  mt-1  text-start " style={{  }}>
                                        <p className="text-semibold text-small color-gray-3">{translate(prop.label)}</p>
                                        <div className="flexc flex-column">
                                            <img className="mrd-2" src={prop.icon} height={18} />
                                            <p className="text-small text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.label)}</p>
                                        </div>

                                        <div className="flexc">
                                            <div className="white flexcc" style={{ minWidth: 20, height: 20, backgroundColor: '#007aff', borderRadius: 30 }}>
                                                <p className="text-smaller text-semibold">{index + 1}</p>
                                            </div>

                                        </div>

                                    </button>
                                )
                            })} */}


                                </div>

                                {this.state.selectedParent && (
                                    <div className="d-flex scroll-no-scrollbar px-2 py-2">
                                        {Object.values(diagramComponents).map((cprop, index) => {
                                            // console.log('this.state.selectedParent', this.state.selectedParent)
                                            // console.log('cprop is', cprop)
                                            if (cprop.parents?.includes(this.state.selectedParent?.type) || (cprop.parents?.includes('*') && this.state.selectedParent?.type != 'flowControl')) {
                                                return (
                                                    <div className=" px-1 mb-0" style={{}} key={cprop.key}>
                                                        <div className="form-item flexc px-2 py-1" onClick={() => { if (cprop.isParent) this.showChildsList(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function', this.state.selectedParent)} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function', this.state.selectedParent)} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '2px 3px', cursor: !cprop.isParent ? 'move' : 'pointer', minHeight: 'auto', backgroundColor: '#eee', backgroundImage: 'none', borderRadius: 6 }}>
                                                            <img draggable={false} src={cprop.icon} width="20px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                            <div>
                                                                <p className=" mld-2 text-smaller text-semibold " style={{ whiteSpace: 'nowrap' }} >{checkTranslation(cprop.title)}</p>
                                                                {/* <p className=" mld-2 text-smallest  color-gray-3 " style={{ whiteSpace: 'nowrap' }} >{translate("Workflow")}</p> */}
                                                            </div>
                                                            {cprop.isParent && (
                                                                <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }

                                        })}
                                    </div>
                                )}
                            </div>



                            {/* <div className="mb-3 pb-2" style={{ borderBottom: '0px solid #eee' }} >
                            <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.setState({ openApplets: !this.state.openApplets })} >
                                <div className="text-start ">
                                    <p className="text-normal text-semibold " style={{ color: '#101010' }}>{translate('Applets')}</p>
                                </div>
                                <img className={"mld-2 transition opacity-2 " + (!this.state.openApplets ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                            </button>
                            <div className="" style={{ padding: '0px 2px' }}>
                                <Collapsible open={!this.state.openApplets} transitionTime={100}>
                                    <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                        {this.state.applets.map((cprop, index) => {
                                            return (
                                           
                                                <div className="  mb-0" style={{ padding: 2, width: '100%' }} key={cprop.key}>
                                                    <div className="flexcb h-100 text-center  " onClick={() => { if (cprop.isParent) this.showApplet(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '5px 5px 10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', borderBottom: '1px solid #f2f2f2' }}>
                                                        <div className="flexc">
                                                            <img draggable={false} src={cprop.icon} width="30px" height={'30px'} alt="" style={{ objectFit: 'cover', borderRadius: '30px', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                            <div className="text-start mld-3">
                                                                <p className="mt-0  text-semibold color-gray-3" style={{ fontSize: 11 }} >{checkTranslation(cprop.name)}</p>
                                                                <p className="mt-0  text-semibold color-gray-2" style={{ fontSize: 10 }} >@username</p>
                                                            </div>
                                                        </div>

                                                        <div className="flexcc">
                                                            {cprop.isParent && (
                                                                <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })}
                                    </div>
                                    <div style={{ padding: '0px 2px' }}>

                                      
                                    </div>
                                </Collapsible>
                            </div>
                        </div> */}



                            {/* {Object.values(diagramGroups).map((prop, index) => {
                            return (
                                <div className="mb-2 pb-2" style={{ borderBottom: '0px solid #eee' }} key={prop.key}>
                                    <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(prop.key)} >
                                        <div className="text-start">
                                            <p className="text-normal text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.title)}</p>

                                           
                                        </div>
                                        <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[prop.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                    </button>

                                    <Collapsible open={!this.state.closedGroups[prop.key]} transitionTime={100}>
                                        <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                            {Object.values(diagramComponents).map((cprop, index) => {
                                                if (!cprop.parent && cprop.group === prop.key)
                                                    return (
                                                        <div className=" p-1 mb-0" style={{ width: '50%' }} key={cprop.key}>
                                                            <div className=" h-100 text-center form-item " onClick={() => { if (cprop.isParent) this.showChildsList(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', borderRadius: 2, border: '1px solid #e2e6e8' }}>
                                                                <img draggable={false} src={cprop.icon} width="30px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                <p className="mt-1 text-smaller text-semibold color-gray-3" >{checkTranslation(cprop.title)}</p>

                                                                {cprop.isParent && (
                                                                    <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                            })}
                                        </div>
                                    </Collapsible>
                                </div>
                            )
                        })} */}
                        </div>
                    </div>
                    {/* </SidebarView> */}





                    <SidebarView width={this.props.width} ref={el => this.subSidebarView = el} sideOpen={false} hideOverlay={this.props.hideOverlay} paddingTop={'62px'} widthCondition={{ xs: "12", sm: '28%', md: '28%', lg: "28%", xl: "20%" }}>

                        <div className="scroll-no-scrollbar h-100">
                            <div className="flexc pt-3 mb-3 px-2">
                                <button onClick={() => this.showChildsList()} className="flexc p-0 mx-0 ">
                                    <img className="reverse " src="/images/nexts.png" width="14px" alt="" />
                                    {/* <span className="text-normal">{this.state.selectedParent?.name}</span> */}
                                </button>
                                <p className="text-semibold text-normal px-2" style={{ color: '#101010' }}>{checkTranslation(this.state.selectedParent?.name)}</p>
                            </div>

                            <div className="d-flex mb-2 w-100 " style={{ flexWrap: 'wrap', alignItems: "stretch" }}>

                                {Object.values(diagramGroups).map((prop, index) => {
                                    return (
                                        <div className="mb-2 pb-2 w-100" style={{ borderBottom: '0px solid #eee' }} key={prop.key}>
                                            <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(prop.key)} >
                                                <div className="text-start">
                                                    <p className="text-small text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.title)}</p>

                                                    {/* <p className="text-normal " style={{ color: '#456' }}>{prop.title}</p> */}
                                                    {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                                </div>
                                                <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[prop.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                            </button>

                                            <Collapsible open={!this.state.closedGroups[prop.key]} transitionTime={100}>

                                                {Object.values(diagramComponents).map((cprop, index) => {
                                                    if (!cprop.parent && cprop.group === prop.key) {
                                                        if (cprop.parents && this.state.selectedParent?.type && cprop.parents.includes(this.state.selectedParent.type)) {
                                                            return (
                                                                // <div className=" p-1 mb-0" style={{ width: '50%' }} key={cprop.key}>
                                                                //     <div onClick={() => { if (cprop.isParent) this.showChildsList(cprop.key) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} className=" h-100 text-center " style={{ touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', backgroundImage: 'linear-gradient(#f2f6f8cc,#eaecef)', borderRadius: 2, border: '1px solid #e2e6e8' }}>
                                                                //         <img draggable={false} src={cprop.icon} width="32px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                //         <p className="" style={{ fontSize: 11, color: '#567', marginTop: 3 }}>{cprop.title}</p>

                                                                //         {cprop.isParent && (
                                                                //             <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                //         )}
                                                                //     </div>
                                                                // </div>

                                                                <div className="  mb-0" style={{ padding: 2, width: '100%' }} key={cprop.key}>
                                                                    <div className="flexcb h-100 text-center  px-2" onClick={() => { this.onClick(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={this.props.draggable && !cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '5px 5px 10px 5px', cursor: (this.props.draggable && !cprop.isParent) ? 'move' : 'pointer', borderBottom: '1px solid #f8f8f8' }}>
                                                                        <div className="flexc">
                                                                            <img draggable={false} src={cprop.icon} width="24px" height={'24px'} alt="" style={{ objectFit: 'cover', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                            <div className="text-start mld-3">
                                                                                <p className="mt-0  text-semibold color-gray-3" style={{ fontSize: 12 }} >{checkTranslation(cprop.title)}</p>
                                                                                {/* <p className="mt-0  text-semibold color-gray-2" style={{ fontSize: 10 }} >@username</p> */}
                                                                            </div>
                                                                        </div>

                                                                        <div className="flexcc">
                                                                            {cprop.isParent && (
                                                                                <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        }
                                                    }
                                                })}

                                            </Collapsible>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </SidebarView>
                    {/* <div className={"blur-back digramSidePanel " + (!this.state.showChildsSide ? 'sideClose' : '')}>
                    <div className="digramSidePanelList pt-3">
                        
                    
                    </div>
                </div> */}
                    <SidebarView width={this.props.width} ref={el => this.varSidebarView = el} sideOpen={false} hideOverlay={this.props.hideOverlay} paddingTop={'62px'} widthCondition={{ xs: "12", sm: '30%', md: '30%', lg: "30%", xl: "24%" }}>
                        <StagesManager ref={el => this.stageManager = el} fast={true} >
                            <div className="py-1 px-2" stageName={'main'} stage={0}>
                                <div className="flexcb mb-2">
                                    <p>Variables</p>
                                    <div style={{ cursor: 'pointer' }} onClick={() => this.addNewVariables()}>
                                        <p className="text-smaller" style={{ color: '#0c53cc' }}>+ Add New</p>
                                    </div>
                                </div>
                                <TableViewer
                                    data={this.props.variablesList}
                                    headers={this.state.headers}
                                    ref={e => this.tableViewer = e}
                                />
                                {/* {this.state.variables?.map((element) => {
                                    console.log('element is ', element)
                                    return (
                                        <div className="mt-3">
                                            <p>{element.name}</p>

                                        </div>
                                    )
                                })} */}
                            </div>
                            <div className="pt-3 px-2" stageName={'addNew'} stage={1}>
                                <div className="flexcb mb-2">
                                    <div className="flexcc">
                                        <button className='flexc' onClick={() => this.backStage('main')}>
                                            <img width={30} className='invert' src="/assets/icons/back-white.svg" />
                                        </button>
                                        <p className="text-small">Add New Variables</p>
                                    </div>
                                    <button className="blue-btn br-10 p-1" onClick={() => this.saveVariables()}>
                                        <p>submit</p>
                                    </button>

                                </div>
                                <FormViewer ref={el => this.form = el} headers={this.state.varHeader} formClass="modern" inputClass={'modern-input'} />
                            </div>
                        </StagesManager>
                    </SidebarView>
                    {this.state.dragId && (
                        <div id="drag-ghost" className="drag-ghost" style={{ zIndex: 20000, position: 'absolute', top: 10, left: 0, height: 80, width: 80, backgroundColor: 'rgba(230,240,245,0.7)', border: '1px dotted #007aff40', borderRadius: 2 }}></div>
                    )}



                </>

            )
        } else {
            return (
                <div></div>
            )
        }
    }

}



export default DiagramTopbar;
